<template>
  <div class="first-row">
    <div class="first-row-logo">
      <img class="bgimg" src="../../assets/images/map/bgimg.png" />
    </div>
    <div class="first-row-title" :style="{height: codingParty ? '130px' : '95px'}">
      <div class="title">
        <p>ESOF x CODMOS에서 준비한 40가지 스테이지</p>
      </div>
      <div class="title">
        <p>뚜앙과 함께 코딩의 기초를 배워봐요.</p>
      </div>
      <div class="title user-count" v-if="isShowCnt">
        <p>
          <span class="user-count">지금까지 {{ userCount }}명이 온라인 코딩 파티에 참여했어요!</span>
        </p>
      </div>
      <template v-if="typeof userCount === 'number'">
        <!-- <div class="title"><p style="font-size: 12px">(전일자 기준)</p></div> -->
      </template>
    </div>
    <div class="first-row-subtitle">
      <div class="first-row-subtitle">
        <div class="subtitle-1">
          <div>
            <p class="first-text">Google Blockly기반</p>
            <p class="first-text">블록코딩 언어 활용</p>
          </div>
        </div>
        <div class="subtitle-1">
          <div>
            <p class="first-text">쉽고 재미있게 배우는</p>
            <p class="first-text">코딩 기초 개념</p>
          </div>
        </div>
        <div class="subtitle-1">
          <div v-if="codingParty">
            <p class="first-text">제어구조(순차,반복,선택,변수)별</p>
            <p class="first-text">미션 별 교육 자료 제공</p>
          </div>
          <div v-else>
            <p class="first-text">학습 결과</p>
            <p class="first-text">분석 리포트 제공</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <a href="/"> -->
      <div class="first-row-logo2" ></div>
    <!-- </a> -->
  </div>
</template>

<script>
    export default {
        name: 'mapHeaderTemplate',
        props: {
          userCount: [Number, String],
          codingParty: Boolean,
          isShowCnt: {
            type: Boolean,
            default: false
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/map/MapPartialHeader.vue